export default "__VITE_ASSET__B8$KJHzu__"